import React from 'react';
import { Code2, Languages } from 'lucide-react';

const TradHumainMachine: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-ivory-50 to-stone-100">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg border border-stone-200 overflow-hidden">
            <div className="bg-gradient-to-r from-copper-500 to-steel-600 p-8 text-white">
              <div className="flex items-center justify-center mb-4">
                <Languages className="h-16 w-16 mr-4" />
                <Code2 className="h-16 w-16" />
              </div>
              <h1 className="text-3xl font-serif font-bold text-center mb-3">
                Traduction Humain-Machine
              </h1>
              <p className="text-ivory-100 text-center text-lg">
                Interface de traduction entre langage humain et langage audio codespeak/gibberlink
              </p>
            </div>

            <div className="p-8">
              <div className="prose prose-stone max-w-none mb-8">
                <p className="text-stone-700 text-lg leading-relaxed">
                  Cet outil permet de traduire des instructions entre le langage naturel humain
                  et le langage audio codespeak/gibberlink machine, facilitant la communication et la
                  compréhension entre les deux univers.
                </p>

                <div className="grid md:grid-cols-2 gap-6 my-8">
                  <div className="bg-copper-50 border border-copper-200 rounded-lg p-6">
                    <h3 className="text-copper-800 font-semibold text-xl mb-3 flex items-center">
                      <Languages className="h-6 w-6 mr-2" />
                      Langage Humain
                    </h3>
                    <p className="text-stone-600">
                      Expressions naturelles, instructions en français, descriptions conceptuelles
                    </p>
                  </div>

                  <div className="bg-steel-50 border border-steel-200 rounded-lg p-6">
                    <h3 className="text-steel-800 font-semibold text-xl mb-3 flex items-center">
                      <Code2 className="h-6 w-6 mr-2" />
                      Langage Audio Machine
                    </h3>
                    <p className="text-stone-600">
                      Codespeak/gibberlink audio, patterns sonores structurés, signaux acoustiques encodés
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white border border-stone-300 rounded-lg overflow-hidden shadow-inner">
                <iframe
                  className="w-full border-0"
                  style={{ height: 'calc(100vh - 500px)', minHeight: '600px' }}
                  title="Traduction Humain-Machine"
                  sandbox="allow-scripts allow-same-origin allow-forms"
                />
              </div>
            </div>
          </div>

          <div className="mt-8 text-center text-stone-500 text-sm">
            <p>
              Cet outil fait partie de l'écosystème MemoMundi.ai
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradHumainMachine;
